module.exports = (left, right) => x => left(x) || right(x)
